module.exports = __webpack_public_path__ + "img/picto-search.172e58ed.svg";